import { Yup } from 'cng-web-lib'
import Namespace from 'src/constants/locale/Namespace'
import {
  constants,
} from 'cng-web-lib'

const {
  locale: {
    key: {
      CommonValidationMessageKeys,
    },
  },
} = constants

function makeValidationSchema(translate) {
  let requiredMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.REQUIRED
  )
  let dateTypeErrorMessage = translate(
    Namespace.COMMON_VALIDATION_MSG,
    CommonValidationMessageKeys.DATE_TYPE_ERROR
  )

  return Yup.object({
    voyageId: Yup.number(),
    createdBy: Yup.number(),
    createdDate: Yup.date().validFormat().typeError(dateTypeErrorMessage),
    updatedBy: Yup.number(),
    updatedDate: Yup.date().validFormat().typeError(dateTypeErrorMessage),
    version: Yup.number(),
    remarks: Yup.string(),
    service: Yup.string(),
    voyageNo: Yup.string(),
    vesselId: Yup.number(),
    partyId: Yup.number(),
    scheduleDocId: Yup.number(),
    scheduleNo: Yup.string(),
    voyageStatus: Yup.string(),
    intVoyageNo: Yup.string(),
    portPair: Yup.string(),
    routeId: Yup.number(),
    transitTime: Yup.number(),
  })
}

export default makeValidationSchema
